import script from "./Confirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./Confirm.vue?vue&type=script&lang=ts&setup=true"

import "./Confirm.vue?vue&type=style&index=0&id=40e23386&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40e23386"]])

export default __exports__